module.exports = __webpack_public_path__ + "static/media/office-2.ded1e1bc.jpg";